import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './ApplePayCard.module.css';
const { REACT_APP_MARKETPLACE_ROOT_URL } = process.env;

const ApplePayButtonContainer = (props) => {
  const { customer, payinTotal, handleSubmitForm, submitDisabled } = props;
  const { amount, currency } = payinTotal || {};
  const { email, profile } = customer?.attributes || {};
  const { firstName, lastName, displayName, protectedData, publicData } = profile || {};
  const { customerId } = publicData || {};
  const { cards: savedCards, mobile_phone_number } = protectedData || {};
  const { callingCode, phoneNumber } = mobile_phone_number || {};

  // State to track if the device supports Apple Pay
  const [isApplePaySupported, setIsApplePaySupported] = useState(false);

  // Detect Apple device and Apple Pay support
  useEffect(() => {
    const isAppleDevice = () => {
      const userAgent = navigator.userAgent;
      const platform = navigator.platform;

      console.log('platform', platform, "and userAgent", userAgent);

      // Check for macOS or iOS devices
      return (
        /Mac|MacIntel|iPhone|iPad|iPod/.test(platform) ||
        /Macintosh|Mac|MacIntel|MacPPC|Mac68K|iPhone|iPad|iPod/.test(userAgent)
      );
    };

    if (isAppleDevice()) {
      setIsApplePaySupported(true);
    }
  }, []);

  // Load Apple Pay SDK and render button
  useEffect(() => {
    if (!isApplePaySupported) return;

    const script = document.createElement('script');
    script.src = 'https://tap-sdks.b-cdn.net/apple-pay/build-1.2.0/main.js';

    script.onload = () => {
      const { render } = window.TapApplepaySDK || {};

      const hasRequiredFields =
        firstName && lastName && email && callingCode && phoneNumber && amount > 0 && !submitDisabled;

      if (render && hasRequiredFields) {
        render(
          {
            debug: REACT_APP_MARKETPLACE_ROOT_URL === 'https://nowoffers.app' ? false : true,
            scope: 'TapToken',
            publicKey: process.env.REACT_APP_TAP_PUBLIC_KEY,
            environment: REACT_APP_MARKETPLACE_ROOT_URL === 'https://nowoffers.app' ? 'production' : 'development',
            merchant: {
              domain: REACT_APP_MARKETPLACE_ROOT_URL.replace(/^https?:\/\//, ''),
              id: process.env.REACT_APP_TAP_MERCHANT_ID,
            },
            acceptance: {
              supportedBrands: ['mada','american_express', 'masterCard', 'visa'],
              supportedCards: 'ALL',
            },
            features: {
              supportsCouponCode: false,
              shippingContactFields: ['name', 'phone', 'email'],
            },
            transaction: {
              amount: amount / 100,
              currency: 'USD',
            },
            customer: {
              id: customerId,
              name: [
                {
                  locale: 'en',
                  first: firstName,
                  last: lastName,
                  middle: '',
                },
              ],
              email: email,
              phone: {
                countryCode: callingCode,
                number: phoneNumber,
              },
            },
            interface: {
              locale: 'en',
              theme: 'dark',
              type: 'buy',
              edges: 'curved',
            },
            onCancel: () => console.log('onCancel'),
            onError: (error) => console.error('onError', error),
            onReady: (test) => console.log('onReady', test),
            onSuccess: async (data, event) => {
              console.log('onSuccess', data);
              console.log('event', event);
              handleSubmitForm({ data });
            },
          },
          'apple-pay-button'
        );
      } else {
        console.warn('Apple Pay not rendered — missing required fields or form is disabled');
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [
    isApplePaySupported,
    submitDisabled,
    firstName,
    lastName,
    email,
    callingCode,
    phoneNumber,
    amount,
  ]);

  // Load Apple Pay CSS
  useEffect(() => {
    if (!isApplePaySupported) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://tap-sdks.b-cdn.net/apple-pay/build-1.2.0/main.css';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [isApplePaySupported]);

  // Render the button only if Apple Pay is supported
  return isApplePaySupported && !submitDisabled ? (
    <>
      <div className={css.socialButtonsOr}>
        <span className={css.socialButtonsOrText}>
          <FormattedMessage id="AuthenticationPage.or" />
        </span>
      </div>
      <div id="apple-pay-button" className={css.applePayButton} />
    </>
  ) : null;
};

export default ApplePayButtonContainer;